<template>
  <span name="state">
    <vs-chip class="ag-grid-cell-chip">
      <span>{{ paramValue }}</span>
    </vs-chip>
    <vs-chip
      class="ag-grid-cell-chip"
      color="primary"
      v-if="params.column.colId == 'Invoice.InvoicePrice' && discount"
    >
      <span>{{ discount }}</span>
    </vs-chip>
    <vs-chip
      class="ag-grid-cell-chip"
      color="dark"
      v-if="params.column.colId == 'Invoice.InvoicePrice' && beforeAmount"
    >
      <span>{{ beforeAmount }}</span>
    </vs-chip>
  </span>
</template>

<script>
export default {
  name: "CellTransactionPrice",
  data() {
    return {
      discount: 0,
      beforeAmount: 0,
    };
  },
  computed: {
    paramValue() {
      if (this.params.column.colId == "Invoice.InvoicePrice") {
        var approvedTransactions = this.params.data.Invoice.Transactions.filter(
          (x) => x.TransactionState == 0
        );
        const sumValues = approvedTransactions.length
          ? Object.values(approvedTransactions).reduce(
              (acc, v) => acc + v.PayPrice,
              0
            )
          : 0;
        var calcPrice = this.params.data.IsPaymentRequired.Amount;
        // this.params.data.Invoice.SettingGroup.Price - sumValues;

        if (!this.params.data.IsPaymentRequired.Need) {
          var mainDiscountAmount = Object.values(
            this.params.data.Invoice.SettingGroup.DiscountRules
          ).reduce((acc, v) => acc + v.DiscountPrice, 0);

          var calcDiscount = mainDiscountAmount;

          if (
            mainDiscountAmount + sumValues ==
            this.params.data.Invoice.SpecialPrice
          )
            calcDiscount = mainDiscountAmount;
          else {
            this.beforeAmount =
              this.params.data.Invoice.SpecialPrice -
              sumValues -
              mainDiscountAmount;
            if (this.beforeAmount > 0.0)
              this.beforeAmount = this.$options.filters.currency(
                this.beforeAmount
              );

            calcDiscount = mainDiscountAmount;
          }
          if (calcDiscount > 0.0)
            this.discount = this.$options.filters.currency(calcDiscount);
        }

        return this.$options.filters.currency(calcPrice);
      } else return this.$options.filters.currency(this.params.value);
    },
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
.ag-grid-cell-chip.transform-6 {
  transform: translateY(6%);
}
</style>
